<template>
  <h3 class="h3">Wann möchtest du das Fahrsicherheitstraining machen?</h3>
  <div v-if="Object.values(trainingsGroupedByMonth).length == 0">
    <p>Derzeit sind keine Trainings verfügbar.</p>
  </div>
  <div v-for="(dates, month) in trainingsGroupedByMonth" :key="month" class="month-group">
    <h4 class="h4">{{ month }}</h4>
    <div class="flex flex-wrap gap-2">
        <DateButton v-for="(item, index) in dates" :key="index" @click="select(item)"
          :id="item.id" :main-text="item.day + ', ' + item.date" :secondary-text="item.start + ' bis ' + item.end + ' Uhr'"
          :is-selected="isSelected(item.id)"
        />
    </div>
  </div>
  <div class="flex justify-between mt-5 items-center">
    <input type="button" class="button prev" :value="Navigation.ZURÜCK" @click="prev"/>
    <input type="button" class="button next" :disabled="nextDisabled" :value="Navigation.WEITER" @click="next"/>
  </div>
  <div class="text-center">
    <span class="!text-gray-200 !text-xs !font-sans">digital begeistert von <a href="https://www.codeandcomments.at" class="!underline !text-xs !text-gray-200 !font-sans">code & comments</a></span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { DetailStep, Navigation, JaNein } from '../../models/enums'
import { dayJsMonthToText, dayJsDayToShortText, scrollToTop } from '../../models/helper'
import { useStore } from 'vuex';
import DateButton from '@/components/DateButton.vue';
import dayjs from 'dayjs';

const store = useStore();
const nextDisabled = computed(() => store.state.selectedTraining == null);
const prev = () => {
  select(null);
  store.commit("stepBack")
  scrollToTop();
};
const next = () => {
  store.commit("updateStep", DetailStep.PERSÖNLICHEDATEN);
  scrollToTop();
}
const select = (item) => store.commit("updateSelectedTraining", item);
const selectedVehicletype = store.state.selectedVehicletype

const isSelected = computed(() => {
  return (id) => store.state.selectedTraining?.id == id;
});
store.dispatch("LOAD_TRAINING_DATES");

const trainingsGroupedByMonth = computed(() => {
  const displayedTrainings = store.state.allTrainings
    .filter(training => {
      const givenDate = dayjs(training.datum);
      const currentDate = dayjs();
      return givenDate.isAfter(currentDate)
    })
    .filter(training => {
      return training.klasse.includes(selectedVehicletype);
    })
    .filter(training => {
      if (store.state.borrowVehicle == JaNein.JA)
        return +training.leihfzgverfuegbar > 0;
      else
        return true
    })
    .reduce((acc, training) => {
      const trainingsDateStart = dayjs(training.datum + training.von, "YYYY-MM-DDHHmm");
      const trainingsDateEnd = dayjs(training.datum + training.bis, "YYYY-MM-DDHHmm");
      const month = dayJsMonthToText(trainingsDateStart.month());

      if (!acc[month]) { acc[month] = []; }
      const preppedData = {
        id: training.id,
        date: trainingsDateStart.format('DD.MM.YYYY'),
        day: dayJsDayToShortText(trainingsDateStart.day()),
        start: trainingsDateStart.format('HH:mm'),
        end: trainingsDateEnd.format('HH:mm')
      };
      acc[month].push(preppedData);

      return acc;
    }, {});
  return displayedTrainings;
});

</script>

<style scoped lang="scss">
h4 {
  @apply mt-3 mb-2;
}
.datebutton {
  @apply w-48;
}
</style>
